import React from "react";

import { ClassCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function vehicleClass({ width, onResize }: Column.Options) {
	return base(ColumnId.Class, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default vehicleClass;
